import React, { useState, useEffect } from "react";
import { api } from "../utils/api";
import logo from "../media/logo.svg";
import SignIn from "./SignIn";
import SignUp from "./SignUp";

export default function Auth({ userAuth }) {
  const [mode, setMode] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [form, setForm] = useState({
    name: "",
    password: "",
    login: "",
    email: "",
    teamName: "",
    mealtyMenu: false,
    mealtyExport: false,
  });

  const onChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const onChangeCheck = (e) => {
    setForm({
      ...form,
      [e.target.name]: !form[e.target.name],
    });
  };

  const signIn = (e) => {
    e.preventDefault();
    setIsLoading(true);
    const { password, login } = form;
    api
      .signIn({ password, login })
      .then((res) => {
        userAuth(res);
        setError(null);
      })
      .catch((res) => {
        res.json().then(({ message }) => setError(message));
      })
      .finally(() => setIsLoading(false));
  };

  const signUp = (e) => {
    e.preventDefault();
    setIsLoading(true);
    const { password, email, name, teamName, mealtyMenu, mealtyExport } = form;
    api
      .signUp({ password, email, name, teamName, mealtyMenu, mealtyExport })
      .then((res) => {
        setMode(1);
        setError(null);
      })
      .catch((res) => {
        res.json().then(({ message }) => setError(message));
      })
      .finally(() => setIsLoading(false));
  };

  return (
    <div className="auth-hero">
      <div className="auth-card glass-panel">
        <div className="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3">
          <div className="d-flex align-items-center gap-3 flex-column flex-sm-row text-center text-sm-start">
            <img alt="Лого" src={logo} style={{ width: 190 }} />
            <div>
              <p className="m-0 text-uppercase text-primary fw-semibold" style={{ letterSpacing: ".08em" }}>
                Еда как сервис
              </p>
              <h3 className="m-0 fw-bold">Питание команды в один клик</h3>
            </div>
          </div>
        </div>
        {mode === 1 ? (
          <SignIn
            signIn={signIn}
            form={form}
            onChange={onChange}
            isLoading={isLoading}
          />
        ) : (
          <SignUp
            signUp={signUp}
            form={form}
            onChange={onChange}
            onChangeCheck={onChangeCheck}
            isLoading={isLoading}
          />
        )}
        {error ? (
          <p className="text-danger fw-semibold text-center mt-3">{error}</p>
        ) : (
          ""
        )}
        <p
          className="mt-3 fs-5 text-center auth-switch"
          onClick={() => (mode === 1 ? setMode(2) : setMode(1))}
        >
          {mode === 2 ? "Вернуться к входу" : "Зарегистрировать команду"}
        </p>
      </div>
    </div>
  );
}
